// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import Mask from '/react4xp/components/Mask'
import AnimatedArrow from '/react4xp/components/AnimatedArrow'

// prop types
interface ProductBlockHorizontalProps {

    // section props
    section: {
        bgColor: 'blue' | 'blue-dark' | 'yoghurt'
        noSeparator?: boolean
        paddingTop?: 'small' | 'medium' | 'big' | 'none'
        paddingBottom?: 'small' | 'medium' | 'big' | 'none'
    }

    // product card props
    productPosition: 'left' | 'right'
    tilt?: 'left' | 'right'
    hoverTilt?: 'left' | 'right'
    href: string
    external?: boolean
    src: string
    srcMobile: string
    alt?: string
    width?: number
    sizes?: string
    title: string
    desc: string
    className?: string
}

export default function ProductBlockHorizontal({
    section,
    productPosition,
    href,
    external,
    src,
    srcMobile,
    alt,
    width,
    sizes,
    title,
    desc,
    tilt,
    hoverTilt,
    className
}: ProductBlockHorizontalProps) {
    return (
        <Section
            bgColor={section.bgColor}
            noSeparator={section.noSeparator}
            paddingTop={section.paddingTop}
            paddingBottom={section.paddingBottom}
            className='product-block-horizontal'
        >
            <div className='container'>
                <div className='row'>
                    <div className='offset-lg-1 col-lg-10'>
                        <a
                            href={href}
                            target={external ? '_blank' : undefined}
                            className={clsx(
                                'product-block-horizontal__link',

                                // product position
                                productPosition === 'left' && 'product-block-horizontal__link--left',
                                productPosition === 'right' && 'product-block-horizontal__link--right',

                                // tilt (rotate the image 10deg left or right)
                                tilt === 'left' && 'product-block-horizontal__link--tilt-left',
                                tilt === 'right' && 'product-block-horizontal__link--tilt-right',
                                hoverTilt === 'left' && 'product-block-horizontal__link--hover-tilt-left',
                                hoverTilt === 'right' && 'product-block-horizontal__link--hover-tilt-right',

                                className
                            )}
                        >
                            
                            <div className='product-block-horizontal__image'>
                                <Image
                                    src={src}
                                    alt={alt}
                                    width={width}
                                    sizes={sizes}
                                    className='product-block-horizontal__image__desktop'
                                />

                                <Image
                                    src={srcMobile}
                                    alt={alt}
                                    width={width}
                                    sizes={sizes}
                                    className='product-block-horizontal__image__mobile'
                                />
                            </div>

                            <Mask
                                bgColor='white'
                                spacing='medium'
                                className='product-block-horizontal__box'
                            >

                                <h3 className='h2'>
                                    {title}
                                </h3>

                                <div
                                    className='product-block-horizontal__box__desc'
                                    dangerouslySetInnerHTML={{ __html: desc }}
                                    suppressHydrationWarning
                                />

                                <AnimatedArrow className='product-block-horizontal__box__arrow' />

                            </Mask>

                        </a>
                    </div>
                </div>
            </div>
        </Section>
    )
}